import React from 'react';

import styled from 'styled-components';

import { TotemImage } from 'components/TotemImage';
import {
    GetMicrostoreSitesWithLocationsInfoQuery,
    GetAllProductsQuery,
    LocationPlanogramFragmentFragment,
} from 'data/__generated__';

export const PlanogramLocation = ({
    location,
    locationPlanogram,
    products,
}: {
    location: GetMicrostoreSitesWithLocationsInfoQuery['sites'][number]['microstoreColumnGroups'][number]['columns'][number]['shelves'][number]['locationTable'][number][number];
    locationPlanogram: LocationPlanogramFragmentFragment | null;
    products: GetAllProductsQuery['getAllProducts'];
}) => {
    const {
        microstoreLocationTemplate: { productArrangement, product },
    } = location;

    const locationPlanogramProduct = products.find(({ _id }) => _id === locationPlanogram?.productId);
    return (
        <Location>
            <>
                {productArrangement ? (
                    <LocationProductArrangementName>{productArrangement.name}</LocationProductArrangementName>
                ) : null}
                {product ? <LocationProductArrangementName>{product.name}</LocationProductArrangementName> : null}
                {locationPlanogramProduct ? (
                    <>
                        <LocationProductName>{locationPlanogramProduct.fullname}</LocationProductName>
                        <TotemImage
                            src={locationPlanogramProduct.imageUrl}
                            alt={locationPlanogramProduct.fullname}
                            size={50}
                        />
                    </>
                ) : null}
            </>
        </Location>
    );
};

const Location = styled.div`
    flex: 1 0 0;
    border: 1px solid ${({ theme }) => theme.lightBorderColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    & > :not(:first-child) {
        margin-top: 5px;
    }
`;

const LocationProductArrangementName = styled.div`
    text-align: center;
    font-size: 12px;
    font-weight: bold;
`;

const LocationProductName = styled.div`
    text-align: center;
    font-size: 13px;
`;
